import React from "react";
import { useNavigate } from "react-router-dom";

const ThankYou = () => {
  const navigate = useNavigate();

  return (
    <div className="container d-flex align-items-center justify-content-center min-vh-100">
      <div className="card shadow-lg border-0 text-center p-5" style={{ maxWidth: "550px" }}>
        
        {/* Success Icon */}
        <div className="mb-4">
          <div
            className="rounded-circle bg-success text-white d-inline-flex align-items-center justify-content-center"
            style={{ width: "80px", height: "80px", fontSize: "40px" }}
          >
            ✓
          </div>
        </div>

        {/* Heading */}
        <h2 className="fw-bold text-success mb-3">
          Payment Submitted Successfully!
        </h2>

        {/* Message */}
        <p className="text-muted mb-4">
          Thank you for your payment.  
          Our team will verify your transaction shortly.  
          Once approved, you will receive confirmation via your selected delivery method.
        </p>

        {/* Buttons */}
        <div className="d-flex gap-3 justify-content-center">
          <button
            className="btn btn-primary px-4"
            onClick={() => navigate("/")}
          >
            Go to Home
          </button>

          <button
            className="btn btn-outline-secondary px-4"
            onClick={() => navigate("./index.js")}
          >
            Home
          </button>
        </div>

      </div>
    </div>
  );
};

export default ThankYou;
